import axios from 'axios';
import BaseApi from './base-api';

class LocationsApi extends BaseApi {
  getLocationByLatLong(latitude, longitude) {
    return axios
      .get(
        this.baseUrl +
          '/locations/reverse_geocode?lat=' +
          latitude +
          '&lon=' +
          longitude
      )
      .then((response) => {
        return {
          ok: true,
          location: response.data,
        };
      })
      .catch((error) => {
        return {
          ok: false,
          errors: error.response.data.errors,
        };
      });
  }
}

export default LocationsApi = new LocationsApi();



// WEBPACK FOOTER //
// ./src/services/api/locations-api.js